import React from 'react';
import PrivacyPolicy from './PrivacyPolicy';

const Privacy = () => {
  return <PrivacyPolicy />;
};

export default Privacy;